import type { Locale } from '@embedpdf/react/i18n';

/** Spanish pack — loaded lazily (see the i18n `loaders` config in App). The
 *  longer Spanish labels are exactly what makes the measured toolbar re-solve
 *  on locale switch, with zero configuration. */
export const es: Locale = {
  code: 'es',
  name: 'Español',
  translations: {
    commands: {
      zoom: {
        in: 'Acercar',
        out: 'Alejar',
        fitPage: 'Ajustar a la página',
        fitWidth: 'Ajustar al ancho',
        automatic: 'Automático',
        menu: 'Zoom',
        level: 'Nivel de zoom',
        p50: '50 %',
        p100: '100 %',
        p150: '150 %',
        p200: '200 %',
        p400: '400 %',
      },
      pan: 'Desplazar',
      pointer: 'Puntero',
      sidebar: 'Barra lateral',
      search: 'Buscar',
      comment: 'Comentario',
      style: 'Estilo',
      menu: 'Menú',
      viewControls: 'Controles de vista',
      download: 'Descargar',
      print: 'Imprimir',
      fullscreen: 'Pantalla completa',
      spread: {
        group: 'Diseño de página',
        none: 'Una página',
        odd: 'Dos páginas',
        even: 'Portada',
      },
      scroll: { group: 'Desplazamiento', vertical: 'Vertical', horizontal: 'Horizontal' },
      rotate: {
        group: 'Girar',
        clockwise: 'Girar a la derecha',
        counterclockwise: 'Girar a la izquierda',
      },
      mode: {
        group: 'Modo',
        view: 'Ver',
        annotate: 'Anotar',
        shapes: 'Formas',
        insert: 'Insertar',
        form: 'Formulario',
        redact: 'Redactar',
      },
      annotate: {
        highlight: 'Resaltar',
        strikeout: 'Tachar',
        underline: 'Subrayar',
        squiggly: 'Ondulado',
        ink: 'Dibujar',
        inkHighlight: 'Resaltador a mano alzada',
        text: 'Texto',
        insertText: 'Insertar texto',
        replaceText: 'Reemplazar texto',
        callout: 'Llamada',
        note: 'Comentario',
        link: 'Enlace',
        gotoLink: 'Ir al enlace',
        removeLink: 'Quitar enlace',
        delete: 'Eliminar',
        group: 'Agrupar',
        ungroup: 'Desagrupar',
        strip: 'Acciones de anotación',
      },
      shapes: {
        rectangle: 'Rectángulo',
        circle: 'Círculo',
        line: 'Línea',
        arrow: 'Flecha',
        polygon: 'Polígono',
        polyline: 'Polilínea',
      },
      insert: {
        attachment: 'Adjuntar archivo',
        stamp: 'Sello',
        signature: 'Firma',
        image: 'Imagen',
      },
      form: {
        textfield: 'Campo de texto',
        checkbox: 'Casilla',
        radio: 'Botón de opción',
        select: 'Desplegable',
        listbox: 'Lista',
      },
      redact: {
        mark: 'Marcar para redacción',
        applyAll: 'Aplicar redacciones',
        clearAll: 'Borrar marcas',
        panel: 'Redacciones',
      },
      undo: 'Deshacer',
      redo: 'Rehacer',
    },
    passwordPrompt: {
      title: 'Contraseña requerida',
      required: 'Este documento está protegido con contraseña. Introdúcela para abrirlo.',
      incorrect: 'La contraseña es incorrecta. Inténtalo de nuevo.',
      incorrectWarning: 'Contraseña incorrecta',
      label: 'Contraseña',
      placeholder: 'Introduce la contraseña',
      cancel: 'Cancelar',
      open: 'Abrir',
      opening: 'Abriendo…',
    },
    documentError: {
      title: 'No se pudo abrir el documento',
      unknown: 'El documento no se pudo abrir.',
      close: 'Cerrar documento',
    },
    demo: {
      starting: 'Iniciando el visor…',
      opening: 'Abriendo el documento…',
      more: 'Más',
      thumbnails: 'Miniaturas',
      outline: 'Esquema',
      searchPlaceholder: 'Buscar en el documento…',
      searchTitle: 'Buscar',
      searchCaseSensitive: 'Distinguir mayúsculas',
      searchWholeWord: 'Palabra completa',
      searchRegex: 'Expresión regular',
      searchSearching: 'Buscando…',
      searchResults: '{count} resultados encontrados',
      searchNoResults: 'Sin resultados',
      searchPage: 'Página {page}',
      commentsTitle: 'Comentarios',
      styleTitle: 'Estilo',
      empty: 'Aquí todavía no hay nada en este panel de demostración.',
      page: 'Página {current} de {total}',
      cancel: 'Cancelar',
      pageBadge: 'pág. {page}',
      redactionTitle: 'Redacciones',
      redactionEmpty:
        'No hay redacciones pendientes. Usa la herramienta Redactar para marcar texto o áreas.',
      redactionArea: 'Marca de área',
      redactionText: 'Marca de texto',
      redactionRemove: 'Quitar marca',
      redactConfirmTitle: '¿Aplicar redacciones?',
      redactConfirmBody:
        'Eliminar permanentemente el contenido bajo {count} marcas de redacción. No se puede deshacer.',
      redactConfirmCollateral: 'También se eliminarán {count} otras anotaciones.',
      redactApply: 'Aplicar',
      redactApplying: 'Aplicando…',
      redactLabelTitle: 'Etiqueta de redacción',
      redactLabelPlaceholder: 'p. ej. REDACTADO',
      redactLabelRepeat: 'Repetir etiqueta en toda la región',
    },
  },
};
